import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDateTime',
  standalone: false,
})
@Injectable({
  providedIn: 'root', // 👈 this is necessary for injection to work
})
export class FormatDateTimePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return '';

    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

    const pad = (n: number) => n.toString().padStart(2, '0');

    // if (isEnd) {
    //   // For end date, we want to show the last second of the day
    //   date.setHours(23, 59, 59, 999);
    // } else {
    //   // For start date, we want to show the first second of the day
    //   date.setHours(0, 0, 0, 0);
    // }

    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`
    );
  }
}
